// extracted by mini-css-extract-plugin
export default {"link":"RTAy5h","PlasticButton":"si14dw","plasticButton":"si14dw","label":"zwZCtl","mainColor":"TFCcsC","pose":"CkIK23","topper":"NyxQYx","oval":"I2lxEq","bord":"_0VhsIp"};